@if (hasQuinnyAI) {
<div class="alain-default__nav-item" nz-dropdown nzTrigger="click" nzPlacement="bottomCenter" [nzDropdownMenu]="aiMenu">
  <img src="https://cdn.qne.cloud/qca/assets/img/quinny-ai-logo.webp" alt="Quinny AI"
    class="chat-icon hidden-mobile" width="120" height="35" style="cursor: pointer;" />
  <img [src]="quinnyAiAvatarUrl" alt="Quinny AI" class="chat-icon hidden-pc" width="25" height="25"
    style="cursor: pointer;" />
</div>

<nz-dropdown-menu #aiMenu="nzDropdownMenu" nzTheme="dark">
  <ul nz-menu nzTheme="dark">
    <li nz-menu-item [nzDisabled]="!canViewAssistant" nz-tooltip
      [nzTooltipTitle]="!canViewAssistant ? noPermissionTip : ''" nzTooltipPlacement="left"
      (click)="canViewAssistant && navigateToAI('/ai/copilot')">
      <span>Quinny AI</span>
      <span class="badge">Beta</span>
    </li>
    <li nz-menu-item [nzDisabled]="!canViewReportAnalyzer" nz-tooltip
      [nzTooltipTitle]="!canViewReportAnalyzer ? noPermissionTip : ''" nzTooltipPlacement="left"
      (click)="canViewReportAnalyzer && navigateToAI('/ai/report-analyzer')">
      <span>Quinny AI Report Analyzer</span>
      <span class="badge">Beta</span>
    </li>
    <li nz-menu-item [nzDisabled]="!canViewReportDesignerAI" nz-tooltip
      [nzTooltipTitle]="!canViewReportDesignerAI ? noPermissionTip : ''" nzTooltipPlacement="left"
      (click)="canViewReportDesignerAI && navigateToAI('/ai/report-designer')">
      <span>Quinny AI Report Designer</span>
      <span class="badge">Beta</span>
    </li>
    <li nz-menu-item [nzDisabled]="!canViewFinancialAdvisor" nz-tooltip
      [nzTooltipTitle]="!canViewFinancialAdvisor ? noPermissionTip : ''" nzTooltipPlacement="left"
      (click)="canViewFinancialAdvisor && navigateToAI('/ai/financial-advisor')">
      <span>Quinny AI Financial Advisor</span>
    </li>
    <li nz-menu-item [nzDisabled]="!canViewConnections" nz-tooltip
      [nzTooltipTitle]="!canViewConnections ? noPermissionTip : ''" nzTooltipPlacement="left"
      (click)="canViewConnections && navigateToAI('/ai/quinny-ai-connections')">
      <span>Quinny AI Channel</span>
    </li>
  </ul>
</nz-dropdown-menu>
}
